import { css } from "@emotion/react";

const stepIndicator = css`
  color: turquoise;

  hr[class*="styles_StepDivider"] {
    margin: 0 10px;
  }
`;

export default { stepIndicator };
